import type { ButtonTextVariant } from '@kanda-libs/ks-design-library';

export const BASE_PROPS = {
  label: 'Save as draft',
  variant: 'outline' as ButtonTextVariant,
  id: 'save-as-draft',
};
